(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/react/pages/invite/helpers/error-handler.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/react/pages/invite/helpers/error-handler.js');

'use strict';

const {
  showUnavailableInviteDialog,
  showInviteErrorDialog
} = svs.arena.pages.invite.dialogs;

const handleInviteError = errorCode => {
  svs.arena.logger.info("Error when accepting invite", errorCode);
  switch (errorCode) {
    case '22 122':
      showInviteErrorDialog('Du är för tillfället i en spelpaus och kan därför inte gå med i ett lag.');
      break;
    case '22 103':
      showUnavailableInviteDialog('Inbjudan hittades inte.');
      break;
    case '22 106':
      showInviteErrorDialog('Laget har redan maximalt antal medlemmar.');
      break;
    case '22 117':
      showUnavailableInviteDialog('Inbjudan är ej längre aktiv.');
      break;
    case '22 116':
      showUnavailableInviteDialog('Du är redan medlem i laget.');
      break;
    default:
      showInviteErrorDialog();
      break;
  }
};
svs.arena.pages.invite.handleInviteError = handleInviteError;

 })(window);